import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { LOGIN_PATH } from 'account/login/Login'

import { User } from 'core/application/account/loginUser'

import { useLoginUserV2 } from 'common/hooks/'

import IchraDecisionToolsWrapper from './IchraDesicionToolWrapper'
import Routes from './Routes'

const IchraDecisionTool = () => {
  const history = useHistory()
  const { user } = useLoginUserV2()

  useEffect(() => {
    if (!isUserAllowedToEnterDashbaord(user)) history.push(LOGIN_PATH)
  }, [])

  const isUserAllowedToEnterDashbaord = (user: User): boolean => {
    // return user !== null && user.permissions.includes(Permissions.AccessIchraDecisionTools);
    //just for development purposes, delete return true when finished
    return true
  }

  return (
    user && (
      <IchraDecisionToolsWrapper user={user}>
        <Routes />
      </IchraDecisionToolsWrapper>
    )
  )
}

export default IchraDecisionTool
